// Generated from c:\c\logic2\src\grammar\vlg.g4 by ANTLR 4.8
// jshint ignore: start
var antlr4 = require('antlr4/index');

 /* eslint-disable */ 


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002U\u02bb\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
    "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
    "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004",
    "F\tF\u0004G\tG\u0004H\tH\u0004I\tI\u0004J\tJ\u0004K\tK\u0004L\tL\u0004",
    "M\tM\u0004N\tN\u0004O\tO\u0004P\tP\u0004Q\tQ\u0004R\tR\u0004S\tS\u0004",
    "T\tT\u0004U\tU\u0004V\tV\u0004W\tW\u0004X\tX\u0004Y\tY\u0004Z\tZ\u0004",
    "[\t[\u0004\\\t\\\u0004]\t]\u0004^\t^\u0004_\t_\u0004`\t`\u0004a\ta\u0004",
    "b\tb\u0004c\tc\u0004d\td\u0004e\te\u0004f\tf\u0003\u0002\u0003\u0002",
    "\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0003",
    "\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0005",
    "\u0003\u0005\u0003\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003\u0007",
    "\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007",
    "\u0003\u0007\u0003\b\u0003\b\u0003\t\u0003\t\u0003\n\u0003\n\u0003\n",
    "\u0003\n\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b\u0003\u000b",
    "\u0003\u000b\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f",
    "\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003",
    "\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000f\u0003\u000f\u0003",
    "\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011\u0003\u0011\u0003",
    "\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003",
    "\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0014\u0003\u0014\u0003\u0014\u0003\u0014\u0003",
    "\u0014\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016\u0003\u0016\u0003",
    "\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003",
    "\u0018\u0003\u0018\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003",
    "\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001b\u0003",
    "\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003",
    "\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003",
    "\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003",
    "\u001f\u0003\u001f\u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003 ",
    "\u0003 \u0003 \u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003",
    "\"\u0003\"\u0003\"\u0003\"\u0003#\u0003#\u0003#\u0003#\u0003#\u0003",
    "$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003$\u0003%\u0003%\u0003%\u0003",
    "%\u0003%\u0003%\u0003%\u0003&\u0003&\u0003&\u0003&\u0003&\u0003&\u0003",
    "\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003(\u0003",
    "(\u0003(\u0003(\u0003(\u0003(\u0003(\u0003)\u0003)\u0003*\u0003*\u0003",
    "*\u0003*\u0003*\u0003*\u0003*\u0003*\u0003+\u0003+\u0003+\u0003+\u0003",
    "+\u0003+\u0003+\u0003+\u0003,\u0003,\u0003,\u0003-\u0003-\u0003-\u0003",
    "-\u0003-\u0003.\u0003.\u0003.\u0003.\u0003.\u0003/\u0003/\u0003/\u0003",
    "/\u0003/\u0003/\u0003/\u0003/\u00030\u00030\u00031\u00031\u00031\u0003",
    "1\u00031\u00031\u00031\u00031\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00033\u00033\u00034\u00034\u00035\u00035\u00036\u00036\u0003",
    "7\u00037\u00038\u00038\u00038\u00038\u00038\u00039\u00039\u00039\u0003",
    "9\u00059\u01ee\n9\u00039\u00059\u01f1\n9\u0003:\u0005:\u01f4\n:\u0003",
    ":\u0003:\u0003:\u0003;\u0005;\u01fa\n;\u0003;\u0003;\u0003;\u0003<\u0005",
    "<\u0200\n<\u0003<\u0003<\u0003<\u0003=\u0003=\u0003>\u0003>\u0003?\u0003",
    "?\u0003?\u0007?\u020c\n?\f?\u000e?\u020f\u000b?\u0003@\u0003@\u0003",
    "@\u0007@\u0214\n@\f@\u000e@\u0217\u000b@\u0003A\u0003A\u0003A\u0007",
    "A\u021c\nA\fA\u000eA\u021f\u000bA\u0003B\u0003B\u0003B\u0007B\u0224",
    "\nB\fB\u000eB\u0227\u000bB\u0003C\u0003C\u0003C\u0007C\u022c\nC\fC\u000e",
    "C\u022f\u000bC\u0003D\u0003D\u0005D\u0233\nD\u0003D\u0003D\u0003E\u0003",
    "E\u0005E\u0239\nE\u0003E\u0003E\u0003F\u0003F\u0005F\u023f\nF\u0003",
    "F\u0003F\u0003G\u0003G\u0005G\u0245\nG\u0003G\u0003G\u0003H\u0003H\u0003",
    "I\u0003I\u0003J\u0003J\u0003J\u0005J\u0250\nJ\u0003K\u0003K\u0003K\u0005",
    "K\u0255\nK\u0003L\u0003L\u0003L\u0005L\u025a\nL\u0003M\u0003M\u0003",
    "N\u0003N\u0003O\u0003O\u0003P\u0003P\u0003Q\u0003Q\u0003Q\u0003R\u0003",
    "R\u0003R\u0003S\u0003S\u0003T\u0003T\u0003U\u0003U\u0003V\u0003V\u0003",
    "W\u0003W\u0003X\u0003X\u0003Y\u0003Y\u0003Z\u0003Z\u0003[\u0003[\u0003",
    "\\\u0003\\\u0003\\\u0003]\u0003]\u0003^\u0003^\u0003^\u0003_\u0003_",
    "\u0003_\u0003`\u0003`\u0003`\u0003a\u0003a\u0003a\u0003b\u0003b\u0003",
    "b\u0003c\u0003c\u0003c\u0003c\u0007c\u0294\nc\fc\u000ec\u0297\u000b",
    "c\u0003c\u0005c\u029a\nc\u0003c\u0003c\u0003c\u0003c\u0003d\u0003d\u0003",
    "d\u0003d\u0007d\u02a4\nd\fd\u000ed\u02a7\u000bd\u0003d\u0003d\u0003",
    "d\u0003d\u0003d\u0003e\u0003e\u0007e\u02b0\ne\fe\u000ee\u02b3\u000b",
    "e\u0003f\u0006f\u02b6\nf\rf\u000ef\u02b7\u0003f\u0003f\u0004\u0295\u02a5",
    "\u0002g\u0003\u0003\u0005\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b",
    "\u000f\t\u0011\n\u0013\u000b\u0015\f\u0017\r\u0019\u000e\u001b\u000f",
    "\u001d\u0010\u001f\u0011!\u0012#\u0013%\u0014\'\u0015)\u0016+\u0017",
    "-\u0018/\u00191\u001a3\u001b5\u001c7\u001d9\u001e;\u001f= ?!A\"C#E$",
    "G%I&K\'M(O)Q*S+U,W-Y.[/]0_1a2c3e4g5i6k7m8o9q:s;u<w=y\u0002{\u0002}\u0002",
    "\u007f\u0002\u0081\u0002\u0083\u0002\u0085\u0002\u0087\u0002\u0089\u0002",
    "\u008b\u0002\u008d\u0002\u008f\u0002\u0091\u0002\u0093\u0002\u0095\u0002",
    "\u0097\u0002\u0099\u0002\u009b\u0002\u009d>\u009f?\u00a1@\u00a3A\u00a5",
    "B\u00a7C\u00a9D\u00abE\u00adF\u00afG\u00b1H\u00b3I\u00b5J\u00b7K\u00b9",
    "L\u00bbM\u00bdN\u00bfO\u00c1P\u00c3Q\u00c5R\u00c7S\u00c9T\u00cbU\u0003",
    "\u0002\u0012\u0004\u0002--//\u0004\u0002UUuu\u0004\u0002FFff\u0004\u0002",
    "DDdd\u0004\u0002QQqq\u0004\u0002JJjj\u0003\u00023;\u0003\u00022;\u0003",
    "\u000223\u0003\u000229\u0005\u00022;CHch\u0004\u0002ZZzz\u0005\u0002",
    "AA\\\\||\u0005\u0002C\\aac|\u0007\u0002&&2;C\\aac|\u0005\u0002\u000b",
    "\f\u000f\u000f\"\"\u0002\u02c6\u0002\u0003\u0003\u0002\u0002\u0002\u0002",
    "\u0005\u0003\u0002\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002",
    "\t\u0003\u0002\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002",
    "\r\u0003\u0002\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002",
    "\u0011\u0003\u0002\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002",
    "\u0015\u0003\u0002\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002",
    "\u0019\u0003\u0002\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u0002",
    "\u001d\u0003\u0002\u0002\u0002\u0002\u001f\u0003\u0002\u0002\u0002\u0002",
    "!\u0003\u0002\u0002\u0002\u0002#\u0003\u0002\u0002\u0002\u0002%\u0003",
    "\u0002\u0002\u0002\u0002\'\u0003\u0002\u0002\u0002\u0002)\u0003\u0002",
    "\u0002\u0002\u0002+\u0003\u0002\u0002\u0002\u0002-\u0003\u0002\u0002",
    "\u0002\u0002/\u0003\u0002\u0002\u0002\u00021\u0003\u0002\u0002\u0002",
    "\u00023\u0003\u0002\u0002\u0002\u00025\u0003\u0002\u0002\u0002\u0002",
    "7\u0003\u0002\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003",
    "\u0002\u0002\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002",
    "\u0002\u0002\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002",
    "\u0002\u0002E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002",
    "\u0002I\u0003\u0002\u0002\u0002\u0002K\u0003\u0002\u0002\u0002\u0002",
    "M\u0003\u0002\u0002\u0002\u0002O\u0003\u0002\u0002\u0002\u0002Q\u0003",
    "\u0002\u0002\u0002\u0002S\u0003\u0002\u0002\u0002\u0002U\u0003\u0002",
    "\u0002\u0002\u0002W\u0003\u0002\u0002\u0002\u0002Y\u0003\u0002\u0002",
    "\u0002\u0002[\u0003\u0002\u0002\u0002\u0002]\u0003\u0002\u0002\u0002",
    "\u0002_\u0003\u0002\u0002\u0002\u0002a\u0003\u0002\u0002\u0002\u0002",
    "c\u0003\u0002\u0002\u0002\u0002e\u0003\u0002\u0002\u0002\u0002g\u0003",
    "\u0002\u0002\u0002\u0002i\u0003\u0002\u0002\u0002\u0002k\u0003\u0002",
    "\u0002\u0002\u0002m\u0003\u0002\u0002\u0002\u0002o\u0003\u0002\u0002",
    "\u0002\u0002q\u0003\u0002\u0002\u0002\u0002s\u0003\u0002\u0002\u0002",
    "\u0002u\u0003\u0002\u0002\u0002\u0002w\u0003\u0002\u0002\u0002\u0002",
    "\u009d\u0003\u0002\u0002\u0002\u0002\u009f\u0003\u0002\u0002\u0002\u0002",
    "\u00a1\u0003\u0002\u0002\u0002\u0002\u00a3\u0003\u0002\u0002\u0002\u0002",
    "\u00a5\u0003\u0002\u0002\u0002\u0002\u00a7\u0003\u0002\u0002\u0002\u0002",
    "\u00a9\u0003\u0002\u0002\u0002\u0002\u00ab\u0003\u0002\u0002\u0002\u0002",
    "\u00ad\u0003\u0002\u0002\u0002\u0002\u00af\u0003\u0002\u0002\u0002\u0002",
    "\u00b1\u0003\u0002\u0002\u0002\u0002\u00b3\u0003\u0002\u0002\u0002\u0002",
    "\u00b5\u0003\u0002\u0002\u0002\u0002\u00b7\u0003\u0002\u0002\u0002\u0002",
    "\u00b9\u0003\u0002\u0002\u0002\u0002\u00bb\u0003\u0002\u0002\u0002\u0002",
    "\u00bd\u0003\u0002\u0002\u0002\u0002\u00bf\u0003\u0002\u0002\u0002\u0002",
    "\u00c1\u0003\u0002\u0002\u0002\u0002\u00c3\u0003\u0002\u0002\u0002\u0002",
    "\u00c5\u0003\u0002\u0002\u0002\u0002\u00c7\u0003\u0002\u0002\u0002\u0002",
    "\u00c9\u0003\u0002\u0002\u0002\u0002\u00cb\u0003\u0002\u0002\u0002\u0003",
    "\u00cd\u0003\u0002\u0002\u0002\u0005\u00d4\u0003\u0002\u0002\u0002\u0007",
    "\u00d6\u0003\u0002\u0002\u0002\t\u00e0\u0003\u0002\u0002\u0002\u000b",
    "\u00e2\u0003\u0002\u0002\u0002\r\u00e4\u0003\u0002\u0002\u0002\u000f",
    "\u00ee\u0003\u0002\u0002\u0002\u0011\u00f0\u0003\u0002\u0002\u0002\u0013",
    "\u00f2\u0003\u0002\u0002\u0002\u0015\u00f6\u0003\u0002\u0002\u0002\u0017",
    "\u00fc\u0003\u0002\u0002\u0002\u0019\u0103\u0003\u0002\u0002\u0002\u001b",
    "\u0108\u0003\u0002\u0002\u0002\u001d\u010e\u0003\u0002\u0002\u0002\u001f",
    "\u0112\u0003\u0002\u0002\u0002!\u0114\u0003\u0002\u0002\u0002#\u0116",
    "\u0003\u0002\u0002\u0002%\u011f\u0003\u0002\u0002\u0002\'\u012a\u0003",
    "\u0002\u0002\u0002)\u012f\u0003\u0002\u0002\u0002+\u0131\u0003\u0002",
    "\u0002\u0002-\u0135\u0003\u0002\u0002\u0002/\u0138\u0003\u0002\u0002",
    "\u00021\u013c\u0003\u0002\u0002\u00023\u0141\u0003\u0002\u0002\u0002",
    "5\u0145\u0003\u0002\u0002\u00027\u014a\u0003\u0002\u0002\u00029\u014e",
    "\u0003\u0002\u0002\u0002;\u0156\u0003\u0002\u0002\u0002=\u015f\u0003",
    "\u0002\u0002\u0002?\u0166\u0003\u0002\u0002\u0002A\u016f\u0003\u0002",
    "\u0002\u0002C\u0176\u0003\u0002\u0002\u0002E\u017a\u0003\u0002\u0002",
    "\u0002G\u017f\u0003\u0002\u0002\u0002I\u0186\u0003\u0002\u0002\u0002",
    "K\u018d\u0003\u0002\u0002\u0002M\u0193\u0003\u0002\u0002\u0002O\u019b",
    "\u0003\u0002\u0002\u0002Q\u01a2\u0003\u0002\u0002\u0002S\u01a4\u0003",
    "\u0002\u0002\u0002U\u01ac\u0003\u0002\u0002\u0002W\u01b4\u0003\u0002",
    "\u0002\u0002Y\u01b7\u0003\u0002\u0002\u0002[\u01bc\u0003\u0002\u0002",
    "\u0002]\u01c1\u0003\u0002\u0002\u0002_\u01c9\u0003\u0002\u0002\u0002",
    "a\u01cb\u0003\u0002\u0002\u0002c\u01d3\u0003\u0002\u0002\u0002e\u01da",
    "\u0003\u0002\u0002\u0002g\u01dc\u0003\u0002\u0002\u0002i\u01de\u0003",
    "\u0002\u0002\u0002k\u01e0\u0003\u0002\u0002\u0002m\u01e2\u0003\u0002",
    "\u0002\u0002o\u01e4\u0003\u0002\u0002\u0002q\u01f0\u0003\u0002\u0002",
    "\u0002s\u01f3\u0003\u0002\u0002\u0002u\u01f9\u0003\u0002\u0002\u0002",
    "w\u01ff\u0003\u0002\u0002\u0002y\u0204\u0003\u0002\u0002\u0002{\u0206",
    "\u0003\u0002\u0002\u0002}\u0208\u0003\u0002\u0002\u0002\u007f\u0210",
    "\u0003\u0002\u0002\u0002\u0081\u0218\u0003\u0002\u0002\u0002\u0083\u0220",
    "\u0003\u0002\u0002\u0002\u0085\u0228\u0003\u0002\u0002\u0002\u0087\u0230",
    "\u0003\u0002\u0002\u0002\u0089\u0236\u0003\u0002\u0002\u0002\u008b\u023c",
    "\u0003\u0002\u0002\u0002\u008d\u0242\u0003\u0002\u0002\u0002\u008f\u0248",
    "\u0003\u0002\u0002\u0002\u0091\u024a\u0003\u0002\u0002\u0002\u0093\u024f",
    "\u0003\u0002\u0002\u0002\u0095\u0254\u0003\u0002\u0002\u0002\u0097\u0259",
    "\u0003\u0002\u0002\u0002\u0099\u025b\u0003\u0002\u0002\u0002\u009b\u025d",
    "\u0003\u0002\u0002\u0002\u009d\u025f\u0003\u0002\u0002\u0002\u009f\u0261",
    "\u0003\u0002\u0002\u0002\u00a1\u0263\u0003\u0002\u0002\u0002\u00a3\u0266",
    "\u0003\u0002\u0002\u0002\u00a5\u0269\u0003\u0002\u0002\u0002\u00a7\u026b",
    "\u0003\u0002\u0002\u0002\u00a9\u026d\u0003\u0002\u0002\u0002\u00ab\u026f",
    "\u0003\u0002\u0002\u0002\u00ad\u0271\u0003\u0002\u0002\u0002\u00af\u0273",
    "\u0003\u0002\u0002\u0002\u00b1\u0275\u0003\u0002\u0002\u0002\u00b3\u0277",
    "\u0003\u0002\u0002\u0002\u00b5\u0279\u0003\u0002\u0002\u0002\u00b7\u027b",
    "\u0003\u0002\u0002\u0002\u00b9\u027e\u0003\u0002\u0002\u0002\u00bb\u0280",
    "\u0003\u0002\u0002\u0002\u00bd\u0283\u0003\u0002\u0002\u0002\u00bf\u0286",
    "\u0003\u0002\u0002\u0002\u00c1\u0289\u0003\u0002\u0002\u0002\u00c3\u028c",
    "\u0003\u0002\u0002\u0002\u00c5\u028f\u0003\u0002\u0002\u0002\u00c7\u029f",
    "\u0003\u0002\u0002\u0002\u00c9\u02ad\u0003\u0002\u0002\u0002\u00cb\u02b5",
    "\u0003\u0002\u0002\u0002\u00cd\u00ce\u0007o\u0002\u0002\u00ce\u00cf",
    "\u0007q\u0002\u0002\u00cf\u00d0\u0007f\u0002\u0002\u00d0\u00d1\u0007",
    "w\u0002\u0002\u00d1\u00d2\u0007n\u0002\u0002\u00d2\u00d3\u0007g\u0002",
    "\u0002\u00d3\u0004\u0003\u0002\u0002\u0002\u00d4\u00d5\u0007=\u0002",
    "\u0002\u00d5\u0006\u0003\u0002\u0002\u0002\u00d6\u00d7\u0007g\u0002",
    "\u0002\u00d7\u00d8\u0007p\u0002\u0002\u00d8\u00d9\u0007f\u0002\u0002",
    "\u00d9\u00da\u0007o\u0002\u0002\u00da\u00db\u0007q\u0002\u0002\u00db",
    "\u00dc\u0007f\u0002\u0002\u00dc\u00dd\u0007w\u0002\u0002\u00dd\u00de",
    "\u0007n\u0002\u0002\u00de\u00df\u0007g\u0002\u0002\u00df\b\u0003\u0002",
    "\u0002\u0002\u00e0\u00e1\u0007%\u0002\u0002\u00e1\n\u0003\u0002\u0002",
    "\u0002\u00e2\u00e3\u0007*\u0002\u0002\u00e3\f\u0003\u0002\u0002\u0002",
    "\u00e4\u00e5\u0007r\u0002\u0002\u00e5\u00e6\u0007c\u0002\u0002\u00e6",
    "\u00e7\u0007t\u0002\u0002\u00e7\u00e8\u0007c\u0002\u0002\u00e8\u00e9",
    "\u0007o\u0002\u0002\u00e9\u00ea\u0007g\u0002\u0002\u00ea\u00eb\u0007",
    "v\u0002\u0002\u00eb\u00ec\u0007g\u0002\u0002\u00ec\u00ed\u0007t\u0002",
    "\u0002\u00ed\u000e\u0003\u0002\u0002\u0002\u00ee\u00ef\u0007+\u0002",
    "\u0002\u00ef\u0010\u0003\u0002\u0002\u0002\u00f0\u00f1\u0007.\u0002",
    "\u0002\u00f1\u0012\u0003\u0002\u0002\u0002\u00f2\u00f3\u0007t\u0002",
    "\u0002\u00f3\u00f4\u0007g\u0002\u0002\u00f4\u00f5\u0007i\u0002\u0002",
    "\u00f5\u0014\u0003\u0002\u0002\u0002\u00f6\u00f7\u0007k\u0002\u0002",
    "\u00f7\u00f8\u0007p\u0002\u0002\u00f8\u00f9\u0007r\u0002\u0002\u00f9",
    "\u00fa\u0007w\u0002\u0002\u00fa\u00fb\u0007v\u0002\u0002\u00fb\u0016",
    "\u0003\u0002\u0002\u0002\u00fc\u00fd\u0007q\u0002\u0002\u00fd\u00fe",
    "\u0007w\u0002\u0002\u00fe\u00ff\u0007v\u0002\u0002\u00ff\u0100\u0007",
    "r\u0002\u0002\u0100\u0101\u0007w\u0002\u0002\u0101\u0102\u0007v\u0002",
    "\u0002\u0102\u0018\u0003\u0002\u0002\u0002\u0103\u0104\u0007v\u0002",
    "\u0002\u0104\u0105\u0007g\u0002\u0002\u0105\u0106\u0007u\u0002\u0002",
    "\u0106\u0107\u0007v\u0002\u0002\u0107\u001a\u0003\u0002\u0002\u0002",
    "\u0108\u0109\u0007d\u0002\u0002\u0109\u010a\u0007g\u0002\u0002\u010a",
    "\u010b\u0007i\u0002\u0002\u010b\u010c\u0007k\u0002\u0002\u010c\u010d",
    "\u0007p\u0002\u0002\u010d\u001c\u0003\u0002\u0002\u0002\u010e\u010f",
    "\u0007g\u0002\u0002\u010f\u0110\u0007p\u0002\u0002\u0110\u0111\u0007",
    "f\u0002\u0002\u0111\u001e\u0003\u0002\u0002\u0002\u0112\u0113\u0007",
    "}\u0002\u0002\u0113 \u0003\u0002\u0002\u0002\u0114\u0115\u0007\u007f",
    "\u0002\u0002\u0115\"\u0003\u0002\u0002\u0002\u0116\u0117\u0007&\u0002",
    "\u0002\u0117\u0118\u0007f\u0002\u0002\u0118\u0119\u0007k\u0002\u0002",
    "\u0119\u011a\u0007u\u0002\u0002\u011a\u011b\u0007r\u0002\u0002\u011b",
    "\u011c\u0007n\u0002\u0002\u011c\u011d\u0007c\u0002\u0002\u011d\u011e",
    "\u0007{\u0002\u0002\u011e$\u0003\u0002\u0002\u0002\u011f\u0120\u0007",
    "n\u0002\u0002\u0120\u0121\u0007q\u0002\u0002\u0121\u0122\u0007e\u0002",
    "\u0002\u0122\u0123\u0007c\u0002\u0002\u0123\u0124\u0007n\u0002\u0002",
    "\u0124\u0125\u0007r\u0002\u0002\u0125\u0126\u0007c\u0002\u0002\u0126",
    "\u0127\u0007t\u0002\u0002\u0127\u0128\u0007c\u0002\u0002\u0128\u0129",
    "\u0007o\u0002\u0002\u0129&\u0003\u0002\u0002\u0002\u012a\u012b\u0007",
    "y\u0002\u0002\u012b\u012c\u0007k\u0002\u0002\u012c\u012d\u0007t\u0002",
    "\u0002\u012d\u012e\u0007g\u0002\u0002\u012e(\u0003\u0002\u0002\u0002",
    "\u012f\u0130\u00070\u0002\u0002\u0130*\u0003\u0002\u0002\u0002\u0131",
    "\u0132\u0007c\u0002\u0002\u0132\u0133\u0007p\u0002\u0002\u0133\u0134",
    "\u0007f\u0002\u0002\u0134,\u0003\u0002\u0002\u0002\u0135\u0136\u0007",
    "q\u0002\u0002\u0136\u0137\u0007t\u0002\u0002\u0137.\u0003\u0002\u0002",
    "\u0002\u0138\u0139\u0007z\u0002\u0002\u0139\u013a\u0007q\u0002\u0002",
    "\u013a\u013b\u0007t\u0002\u0002\u013b0\u0003\u0002\u0002\u0002\u013c",
    "\u013d\u0007p\u0002\u0002\u013d\u013e\u0007c\u0002\u0002\u013e\u013f",
    "\u0007p\u0002\u0002\u013f\u0140\u0007f\u0002\u0002\u01402\u0003\u0002",
    "\u0002\u0002\u0141\u0142\u0007p\u0002\u0002\u0142\u0143\u0007q\u0002",
    "\u0002\u0143\u0144\u0007t\u0002\u0002\u01444\u0003\u0002\u0002\u0002",
    "\u0145\u0146\u0007z\u0002\u0002\u0146\u0147\u0007p\u0002\u0002\u0147",
    "\u0148\u0007q\u0002\u0002\u0148\u0149\u0007t\u0002\u0002\u01496\u0003",
    "\u0002\u0002\u0002\u014a\u014b\u0007p\u0002\u0002\u014b\u014c\u0007",
    "q\u0002\u0002\u014c\u014d\u0007v\u0002\u0002\u014d8\u0003\u0002\u0002",
    "\u0002\u014e\u014f\u0007e\u0002\u0002\u014f\u0150\u0007q\u0002\u0002",
    "\u0150\u0151\u0007p\u0002\u0002\u0151\u0152\u0007v\u0002\u0002\u0152",
    "\u0153\u0007t\u0002\u0002\u0153\u0154\u0007q\u0002\u0002\u0154\u0155",
    "\u0007n\u0002\u0002\u0155:\u0003\u0002\u0002\u0002\u0156\u0157\u0007",
    "t\u0002\u0002\u0157\u0158\u0007g\u0002\u0002\u0158\u0159\u0007u\u0002",
    "\u0002\u0159\u015a\u0007r\u0002\u0002\u015a\u015b\u0007q\u0002\u0002",
    "\u015b\u015c\u0007p\u0002\u0002\u015c\u015d\u0007u\u0002\u0002\u015d",
    "\u015e\u0007g\u0002\u0002\u015e<\u0003\u0002\u0002\u0002\u015f\u0160",
    "\u0007d\u0002\u0002\u0160\u0161\u0007w\u0002\u0002\u0161\u0162\u0007",
    "h\u0002\u0002\u0162\u0163\u0007h\u0002\u0002\u0163\u0164\u0007g\u0002",
    "\u0002\u0164\u0165\u0007t\u0002\u0002\u0165>\u0003\u0002\u0002\u0002",
    "\u0166\u0167\u0007u\u0002\u0002\u0167\u0168\u0007g\u0002\u0002\u0168",
    "\u0169\u0007x\u0002\u0002\u0169\u016a\u0007g\u0002\u0002\u016a\u016b",
    "\u0007p\u0002\u0002\u016b\u016c\u0007u\u0002\u0002\u016c\u016d\u0007",
    "g\u0002\u0002\u016d\u016e\u0007i\u0002\u0002\u016e@\u0003\u0002\u0002",
    "\u0002\u016f\u0170\u0007p\u0002\u0002\u0170\u0171\u0007w\u0002\u0002",
    "\u0171\u0172\u0007o\u0002\u0002\u0172\u0173\u0007d\u0002\u0002\u0173",
    "\u0174\u0007g\u0002\u0002\u0174\u0175\u0007t\u0002\u0002\u0175B\u0003",
    "\u0002\u0002\u0002\u0176\u0177\u0007n\u0002\u0002\u0177\u0178\u0007",
    "g\u0002\u0002\u0178\u0179\u0007f\u0002\u0002\u0179D\u0003\u0002\u0002",
    "\u0002\u017a\u017b\u0007n\u0002\u0002\u017b\u017c\u0007g\u0002\u0002",
    "\u017c\u017d\u0007f\u0002\u0002\u017d\u017e\u0007u\u0002\u0002\u017e",
    "F\u0003\u0002\u0002\u0002\u017f\u0180\u0007n\u0002\u0002\u0180\u0181",
    "\u0007g\u0002\u0002\u0181\u0182\u0007f\u0002\u0002\u0182\u0183\u0007",
    "d\u0002\u0002\u0183\u0184\u0007c\u0002\u0002\u0184\u0185\u0007t\u0002",
    "\u0002\u0185H\u0003\u0002\u0002\u0002\u0186\u0187\u0007c\u0002\u0002",
    "\u0187\u0188\u0007u\u0002\u0002\u0188\u0189\u0007u\u0002\u0002\u0189",
    "\u018a\u0007k\u0002\u0002\u018a\u018b\u0007i\u0002\u0002\u018b\u018c",
    "\u0007p\u0002\u0002\u018cJ\u0003\u0002\u0002\u0002\u018d\u018e\u0007",
    "&\u0002\u0002\u018e\u018f\u0007o\u0002\u0002\u018f\u0190\u0007g\u0002",
    "\u0002\u0190\u0191\u0007v\u0002\u0002\u0191\u0192\u0007c\u0002\u0002",
    "\u0192L\u0003\u0002\u0002\u0002\u0193\u0194\u0007k\u0002\u0002\u0194",
    "\u0195\u0007p\u0002\u0002\u0195\u0196\u0007k\u0002\u0002\u0196\u0197",
    "\u0007v\u0002\u0002\u0197\u0198\u0007k\u0002\u0002\u0198\u0199\u0007",
    "c\u0002\u0002\u0199\u019a\u0007n\u0002\u0002\u019aN\u0003\u0002\u0002",
    "\u0002\u019b\u019c\u0007c\u0002\u0002\u019c\u019d\u0007n\u0002\u0002",
    "\u019d\u019e\u0007y\u0002\u0002\u019e\u019f\u0007c\u0002\u0002\u019f",
    "\u01a0\u0007{\u0002\u0002\u01a0\u01a1\u0007u\u0002\u0002\u01a1P\u0003",
    "\u0002\u0002\u0002\u01a2\u01a3\u0007B\u0002\u0002\u01a3R\u0003\u0002",
    "\u0002\u0002\u01a4\u01a5\u0007r\u0002\u0002\u01a5\u01a6\u0007q\u0002",
    "\u0002\u01a6\u01a7\u0007u\u0002\u0002\u01a7\u01a8\u0007g\u0002\u0002",
    "\u01a8\u01a9\u0007f\u0002\u0002\u01a9\u01aa\u0007i\u0002\u0002\u01aa",
    "\u01ab\u0007g\u0002\u0002\u01abT\u0003\u0002\u0002\u0002\u01ac\u01ad",
    "\u0007p\u0002\u0002\u01ad\u01ae\u0007g\u0002\u0002\u01ae\u01af\u0007",
    "i\u0002\u0002\u01af\u01b0\u0007g\u0002\u0002\u01b0\u01b1\u0007f\u0002",
    "\u0002\u01b1\u01b2\u0007i\u0002\u0002\u01b2\u01b3\u0007g\u0002\u0002",
    "\u01b3V\u0003\u0002\u0002\u0002\u01b4\u01b5\u0007k\u0002\u0002\u01b5",
    "\u01b6\u0007h\u0002\u0002\u01b6X\u0003\u0002\u0002\u0002\u01b7\u01b8",
    "\u0007g\u0002\u0002\u01b8\u01b9\u0007n\u0002\u0002\u01b9\u01ba\u0007",
    "u\u0002\u0002\u01ba\u01bb\u0007g\u0002\u0002\u01bbZ\u0003\u0002\u0002",
    "\u0002\u01bc\u01bd\u0007e\u0002\u0002\u01bd\u01be\u0007c\u0002\u0002",
    "\u01be\u01bf\u0007u\u0002\u0002\u01bf\u01c0\u0007g\u0002\u0002\u01c0",
    "\\\u0003\u0002\u0002\u0002\u01c1\u01c2\u0007g\u0002\u0002\u01c2\u01c3",
    "\u0007p\u0002\u0002\u01c3\u01c4\u0007f\u0002\u0002\u01c4\u01c5\u0007",
    "e\u0002\u0002\u01c5\u01c6\u0007c\u0002\u0002\u01c6\u01c7\u0007u\u0002",
    "\u0002\u01c7\u01c8\u0007g\u0002\u0002\u01c8^\u0003\u0002\u0002\u0002",
    "\u01c9\u01ca\u0007<\u0002\u0002\u01ca`\u0003\u0002\u0002\u0002\u01cb",
    "\u01cc\u0007f\u0002\u0002\u01cc\u01cd\u0007g\u0002\u0002\u01cd\u01ce",
    "\u0007h\u0002\u0002\u01ce\u01cf\u0007c\u0002\u0002\u01cf\u01d0\u0007",
    "w\u0002\u0002\u01d0\u01d1\u0007n\u0002\u0002\u01d1\u01d2\u0007v\u0002",
    "\u0002\u01d2b\u0003\u0002\u0002\u0002\u01d3\u01d4\u0007&\u0002\u0002",
    "\u01d4\u01d5\u0007g\u0002\u0002\u01d5\u01d6\u0007t\u0002\u0002\u01d6",
    "\u01d7\u0007t\u0002\u0002\u01d7\u01d8\u0007q\u0002\u0002\u01d8\u01d9",
    "\u0007t\u0002\u0002\u01d9d\u0003\u0002\u0002\u0002\u01da\u01db\u0007",
    "A\u0002\u0002\u01dbf\u0003\u0002\u0002\u0002\u01dc\u01dd\u0007]\u0002",
    "\u0002\u01ddh\u0003\u0002\u0002\u0002\u01de\u01df\u0007_\u0002\u0002",
    "\u01dfj\u0003\u0002\u0002\u0002\u01e0\u01e1\u0007)\u0002\u0002\u01e1",
    "l\u0003\u0002\u0002\u0002\u01e2\u01e3\u0007$\u0002\u0002\u01e3n\u0003",
    "\u0002\u0002\u0002\u01e4\u01e5\u0007O\u0002\u0002\u01e5\u01e6\u0007",
    "c\u0002\u0002\u01e6\u01e7\u0007k\u0002\u0002\u01e7\u01e8\u0007p\u0002",
    "\u0002\u01e8p\u0003\u0002\u0002\u0002\u01e9\u01f1\u0005\u007f@\u0002",
    "\u01ea\u01eb\u0005{>\u0002\u01eb\u01ec\u0005\u0087D\u0002\u01ec\u01ee",
    "\u0003\u0002\u0002\u0002\u01ed\u01ea\u0003\u0002\u0002\u0002\u01ed\u01ee",
    "\u0003\u0002\u0002\u0002\u01ee\u01ef\u0003\u0002\u0002\u0002\u01ef\u01f1",
    "\u0005\u007f@\u0002\u01f0\u01e9\u0003\u0002\u0002\u0002\u01f0\u01ed",
    "\u0003\u0002\u0002\u0002\u01f1r\u0003\u0002\u0002\u0002\u01f2\u01f4",
    "\u0005{>\u0002\u01f3\u01f2\u0003\u0002\u0002\u0002\u01f3\u01f4\u0003",
    "\u0002\u0002\u0002\u01f4\u01f5\u0003\u0002\u0002\u0002\u01f5\u01f6\u0005",
    "\u0089E\u0002\u01f6\u01f7\u0005\u0081A\u0002\u01f7t\u0003\u0002\u0002",
    "\u0002\u01f8\u01fa\u0005{>\u0002\u01f9\u01f8\u0003\u0002\u0002\u0002",
    "\u01f9\u01fa\u0003\u0002\u0002\u0002\u01fa\u01fb\u0003\u0002\u0002\u0002",
    "\u01fb\u01fc\u0005\u008bF\u0002\u01fc\u01fd\u0005\u0083B\u0002\u01fd",
    "v\u0003\u0002\u0002\u0002\u01fe\u0200\u0005{>\u0002\u01ff\u01fe\u0003",
    "\u0002\u0002\u0002\u01ff\u0200\u0003\u0002\u0002\u0002\u0200\u0201\u0003",
    "\u0002\u0002\u0002\u0201\u0202\u0005\u008dG\u0002\u0202\u0203\u0005",
    "\u0085C\u0002\u0203x\u0003\u0002\u0002\u0002\u0204\u0205\t\u0002\u0002",
    "\u0002\u0205z\u0003\u0002\u0002\u0002\u0206\u0207\u0005}?\u0002\u0207",
    "|\u0003\u0002\u0002\u0002\u0208\u020d\u0005\u008fH\u0002\u0209\u020c",
    "\u0007a\u0002\u0002\u020a\u020c\u0005\u0091I\u0002\u020b\u0209\u0003",
    "\u0002\u0002\u0002\u020b\u020a\u0003\u0002\u0002\u0002\u020c\u020f\u0003",
    "\u0002\u0002\u0002\u020d\u020b\u0003\u0002\u0002\u0002\u020d\u020e\u0003",
    "\u0002\u0002\u0002\u020e~\u0003\u0002\u0002\u0002\u020f\u020d\u0003",
    "\u0002\u0002\u0002\u0210\u0215\u0005\u0091I\u0002\u0211\u0214\u0007",
    "a\u0002\u0002\u0212\u0214\u0005\u0091I\u0002\u0213\u0211\u0003\u0002",
    "\u0002\u0002\u0213\u0212\u0003\u0002\u0002\u0002\u0214\u0217\u0003\u0002",
    "\u0002\u0002\u0215\u0213\u0003\u0002\u0002\u0002\u0215\u0216\u0003\u0002",
    "\u0002\u0002\u0216\u0080\u0003\u0002\u0002\u0002\u0217\u0215\u0003\u0002",
    "\u0002\u0002\u0218\u021d\u0005\u0093J\u0002\u0219\u021c\u0007a\u0002",
    "\u0002\u021a\u021c\u0005\u0093J\u0002\u021b\u0219\u0003\u0002\u0002",
    "\u0002\u021b\u021a\u0003\u0002\u0002\u0002\u021c\u021f\u0003\u0002\u0002",
    "\u0002\u021d\u021b\u0003\u0002\u0002\u0002\u021d\u021e\u0003\u0002\u0002",
    "\u0002\u021e\u0082\u0003\u0002\u0002\u0002\u021f\u021d\u0003\u0002\u0002",
    "\u0002\u0220\u0225\u0005\u0095K\u0002\u0221\u0224\u0007a\u0002\u0002",
    "\u0222\u0224\u0005\u0095K\u0002\u0223\u0221\u0003\u0002\u0002\u0002",
    "\u0223\u0222\u0003\u0002\u0002\u0002\u0224\u0227\u0003\u0002\u0002\u0002",
    "\u0225\u0223\u0003\u0002\u0002\u0002\u0225\u0226\u0003\u0002\u0002\u0002",
    "\u0226\u0084\u0003\u0002\u0002\u0002\u0227\u0225\u0003\u0002\u0002\u0002",
    "\u0228\u022d\u0005\u0097L\u0002\u0229\u022c\u0007a\u0002\u0002\u022a",
    "\u022c\u0005\u0097L\u0002\u022b\u0229\u0003\u0002\u0002\u0002\u022b",
    "\u022a\u0003\u0002\u0002\u0002\u022c\u022f\u0003\u0002\u0002\u0002\u022d",
    "\u022b\u0003\u0002\u0002\u0002\u022d\u022e\u0003\u0002\u0002\u0002\u022e",
    "\u0086\u0003\u0002\u0002\u0002\u022f\u022d\u0003\u0002\u0002\u0002\u0230",
    "\u0232\u0007)\u0002\u0002\u0231\u0233\t\u0003\u0002\u0002\u0232\u0231",
    "\u0003\u0002\u0002\u0002\u0232\u0233\u0003\u0002\u0002\u0002\u0233\u0234",
    "\u0003\u0002\u0002\u0002\u0234\u0235\t\u0004\u0002\u0002\u0235\u0088",
    "\u0003\u0002\u0002\u0002\u0236\u0238\u0007)\u0002\u0002\u0237\u0239",
    "\t\u0003\u0002\u0002\u0238\u0237\u0003\u0002\u0002\u0002\u0238\u0239",
    "\u0003\u0002\u0002\u0002\u0239\u023a\u0003\u0002\u0002\u0002\u023a\u023b",
    "\t\u0005\u0002\u0002\u023b\u008a\u0003\u0002\u0002\u0002\u023c\u023e",
    "\u0007)\u0002\u0002\u023d\u023f\t\u0003\u0002\u0002\u023e\u023d\u0003",
    "\u0002\u0002\u0002\u023e\u023f\u0003\u0002\u0002\u0002\u023f\u0240\u0003",
    "\u0002\u0002\u0002\u0240\u0241\t\u0006\u0002\u0002\u0241\u008c\u0003",
    "\u0002\u0002\u0002\u0242\u0244\u0007)\u0002\u0002\u0243\u0245\t\u0003",
    "\u0002\u0002\u0244\u0243\u0003\u0002\u0002\u0002\u0244\u0245\u0003\u0002",
    "\u0002\u0002\u0245\u0246\u0003\u0002\u0002\u0002\u0246\u0247\t\u0007",
    "\u0002\u0002\u0247\u008e\u0003\u0002\u0002\u0002\u0248\u0249\t\b\u0002",
    "\u0002\u0249\u0090\u0003\u0002\u0002\u0002\u024a\u024b\t\t\u0002\u0002",
    "\u024b\u0092\u0003\u0002\u0002\u0002\u024c\u0250\u0005\u0099M\u0002",
    "\u024d\u0250\u0005\u009bN\u0002\u024e\u0250\t\n\u0002\u0002\u024f\u024c",
    "\u0003\u0002\u0002\u0002\u024f\u024d\u0003\u0002\u0002\u0002\u024f\u024e",
    "\u0003\u0002\u0002\u0002\u0250\u0094\u0003\u0002\u0002\u0002\u0251\u0255",
    "\u0005\u0099M\u0002\u0252\u0255\u0005\u009bN\u0002\u0253\u0255\t\u000b",
    "\u0002\u0002\u0254\u0251\u0003\u0002\u0002\u0002\u0254\u0252\u0003\u0002",
    "\u0002\u0002\u0254\u0253\u0003\u0002\u0002\u0002\u0255\u0096\u0003\u0002",
    "\u0002\u0002\u0256\u025a\u0005\u0099M\u0002\u0257\u025a\u0005\u009b",
    "N\u0002\u0258\u025a\t\f\u0002\u0002\u0259\u0256\u0003\u0002\u0002\u0002",
    "\u0259\u0257\u0003\u0002\u0002\u0002\u0259\u0258\u0003\u0002\u0002\u0002",
    "\u025a\u0098\u0003\u0002\u0002\u0002\u025b\u025c\t\r\u0002\u0002\u025c",
    "\u009a\u0003\u0002\u0002\u0002\u025d\u025e\t\u000e\u0002\u0002\u025e",
    "\u009c\u0003\u0002\u0002\u0002\u025f\u0260\u0007#\u0002\u0002\u0260",
    "\u009e\u0003\u0002\u0002\u0002\u0261\u0262\u0007\u0080\u0002\u0002\u0262",
    "\u00a0\u0003\u0002\u0002\u0002\u0263\u0264\u0007\u0080\u0002\u0002\u0264",
    "\u0265\u0007(\u0002\u0002\u0265\u00a2\u0003\u0002\u0002\u0002\u0266",
    "\u0267\u0007\u0080\u0002\u0002\u0267\u0268\u0007~\u0002\u0002\u0268",
    "\u00a4\u0003\u0002\u0002\u0002\u0269\u026a\u0007`\u0002\u0002\u026a",
    "\u00a6\u0003\u0002\u0002\u0002\u026b\u026c\u0007?\u0002\u0002\u026c",
    "\u00a8\u0003\u0002\u0002\u0002\u026d\u026e\u0007-\u0002\u0002\u026e",
    "\u00aa\u0003\u0002\u0002\u0002\u026f\u0270\u0007/\u0002\u0002\u0270",
    "\u00ac\u0003\u0002\u0002\u0002\u0271\u0272\u0007(\u0002\u0002\u0272",
    "\u00ae\u0003\u0002\u0002\u0002\u0273\u0274\u0007~\u0002\u0002\u0274",
    "\u00b0\u0003\u0002\u0002\u0002\u0275\u0276\u0007,\u0002\u0002\u0276",
    "\u00b2\u0003\u0002\u0002\u0002\u0277\u0278\u00071\u0002\u0002\u0278",
    "\u00b4\u0003\u0002\u0002\u0002\u0279\u027a\u0007>\u0002\u0002\u027a",
    "\u00b6\u0003\u0002\u0002\u0002\u027b\u027c\u0007>\u0002\u0002\u027c",
    "\u027d\u0007?\u0002\u0002\u027d\u00b8\u0003\u0002\u0002\u0002\u027e",
    "\u027f\u0007@\u0002\u0002\u027f\u00ba\u0003\u0002\u0002\u0002\u0280",
    "\u0281\u0007@\u0002\u0002\u0281\u0282\u0007?\u0002\u0002\u0282\u00bc",
    "\u0003\u0002\u0002\u0002\u0283\u0284\u0007?\u0002\u0002\u0284\u0285",
    "\u0007?\u0002\u0002\u0285\u00be\u0003\u0002\u0002\u0002\u0286\u0287",
    "\u0007#\u0002\u0002\u0287\u0288\u0007?\u0002\u0002\u0288\u00c0\u0003",
    "\u0002\u0002\u0002\u0289\u028a\u0007>\u0002\u0002\u028a\u028b\u0007",
    ">\u0002\u0002\u028b\u00c2\u0003\u0002\u0002\u0002\u028c\u028d\u0007",
    "@\u0002\u0002\u028d\u028e\u0007@\u0002\u0002\u028e\u00c4\u0003\u0002",
    "\u0002\u0002\u028f\u0290\u00071\u0002\u0002\u0290\u0291\u00071\u0002",
    "\u0002\u0291\u0295\u0003\u0002\u0002\u0002\u0292\u0294\u000b\u0002\u0002",
    "\u0002\u0293\u0292\u0003\u0002\u0002\u0002\u0294\u0297\u0003\u0002\u0002",
    "\u0002\u0295\u0296\u0003\u0002\u0002\u0002\u0295\u0293\u0003\u0002\u0002",
    "\u0002\u0296\u0299\u0003\u0002\u0002\u0002\u0297\u0295\u0003\u0002\u0002",
    "\u0002\u0298\u029a\u0007\u000f\u0002\u0002\u0299\u0298\u0003\u0002\u0002",
    "\u0002\u0299\u029a\u0003\u0002\u0002\u0002\u029a\u029b\u0003\u0002\u0002",
    "\u0002\u029b\u029c\u0007\f\u0002\u0002\u029c\u029d\u0003\u0002\u0002",
    "\u0002\u029d\u029e\bc\u0002\u0002\u029e\u00c6\u0003\u0002\u0002\u0002",
    "\u029f\u02a0\u00071\u0002\u0002\u02a0\u02a1\u0007,\u0002\u0002\u02a1",
    "\u02a5\u0003\u0002\u0002\u0002\u02a2\u02a4\u000b\u0002\u0002\u0002\u02a3",
    "\u02a2\u0003\u0002\u0002\u0002\u02a4\u02a7\u0003\u0002\u0002\u0002\u02a5",
    "\u02a6\u0003\u0002\u0002\u0002\u02a5\u02a3\u0003\u0002\u0002\u0002\u02a6",
    "\u02a8\u0003\u0002\u0002\u0002\u02a7\u02a5\u0003\u0002\u0002\u0002\u02a8",
    "\u02a9\u0007,\u0002\u0002\u02a9\u02aa\u00071\u0002\u0002\u02aa\u02ab",
    "\u0003\u0002\u0002\u0002\u02ab\u02ac\bd\u0002\u0002\u02ac\u00c8\u0003",
    "\u0002\u0002\u0002\u02ad\u02b1\t\u000f\u0002\u0002\u02ae\u02b0\t\u0010",
    "\u0002\u0002\u02af\u02ae\u0003\u0002\u0002\u0002\u02b0\u02b3\u0003\u0002",
    "\u0002\u0002\u02b1\u02af\u0003\u0002\u0002\u0002\u02b1\u02b2\u0003\u0002",
    "\u0002\u0002\u02b2\u00ca\u0003\u0002\u0002\u0002\u02b3\u02b1\u0003\u0002",
    "\u0002\u0002\u02b4\u02b6\t\u0011\u0002\u0002\u02b5\u02b4\u0003\u0002",
    "\u0002\u0002\u02b6\u02b7\u0003\u0002\u0002\u0002\u02b7\u02b5\u0003\u0002",
    "\u0002\u0002\u02b7\u02b8\u0003\u0002\u0002\u0002\u02b8\u02b9\u0003\u0002",
    "\u0002\u0002\u02b9\u02ba\bf\u0002\u0002\u02ba\u00cc\u0003\u0002\u0002",
    "\u0002\u001e\u0002\u01ed\u01f0\u01f3\u01f9\u01ff\u020b\u020d\u0213\u0215",
    "\u021b\u021d\u0223\u0225\u022b\u022d\u0232\u0238\u023e\u0244\u024f\u0254",
    "\u0259\u0295\u0299\u02a5\u02b1\u02b7\u0003\u0002\u0003\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function vlgLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

vlgLexer.prototype = Object.create(antlr4.Lexer.prototype);
vlgLexer.prototype.constructor = vlgLexer;

Object.defineProperty(vlgLexer.prototype, "atn", {
        get : function() {
                return atn;
        }
});

vlgLexer.EOF = antlr4.Token.EOF;
vlgLexer.T__0 = 1;
vlgLexer.T__1 = 2;
vlgLexer.T__2 = 3;
vlgLexer.T__3 = 4;
vlgLexer.T__4 = 5;
vlgLexer.T__5 = 6;
vlgLexer.T__6 = 7;
vlgLexer.T__7 = 8;
vlgLexer.T__8 = 9;
vlgLexer.T__9 = 10;
vlgLexer.T__10 = 11;
vlgLexer.T__11 = 12;
vlgLexer.T__12 = 13;
vlgLexer.T__13 = 14;
vlgLexer.T__14 = 15;
vlgLexer.T__15 = 16;
vlgLexer.T__16 = 17;
vlgLexer.T__17 = 18;
vlgLexer.T__18 = 19;
vlgLexer.T__19 = 20;
vlgLexer.T__20 = 21;
vlgLexer.T__21 = 22;
vlgLexer.T__22 = 23;
vlgLexer.T__23 = 24;
vlgLexer.T__24 = 25;
vlgLexer.T__25 = 26;
vlgLexer.T__26 = 27;
vlgLexer.T__27 = 28;
vlgLexer.T__28 = 29;
vlgLexer.T__29 = 30;
vlgLexer.T__30 = 31;
vlgLexer.T__31 = 32;
vlgLexer.T__32 = 33;
vlgLexer.T__33 = 34;
vlgLexer.T__34 = 35;
vlgLexer.T__35 = 36;
vlgLexer.T__36 = 37;
vlgLexer.T__37 = 38;
vlgLexer.T__38 = 39;
vlgLexer.T__39 = 40;
vlgLexer.T__40 = 41;
vlgLexer.T__41 = 42;
vlgLexer.T__42 = 43;
vlgLexer.T__43 = 44;
vlgLexer.T__44 = 45;
vlgLexer.T__45 = 46;
vlgLexer.T__46 = 47;
vlgLexer.T__47 = 48;
vlgLexer.T__48 = 49;
vlgLexer.T__49 = 50;
vlgLexer.T__50 = 51;
vlgLexer.T__51 = 52;
vlgLexer.T__52 = 53;
vlgLexer.T__53 = 54;
vlgLexer.MAIN = 55;
vlgLexer.Decimal_number = 56;
vlgLexer.Binary_number = 57;
vlgLexer.Octal_number = 58;
vlgLexer.Hex_number = 59;
vlgLexer.NOT = 60;
vlgLexer.NEG = 61;
vlgLexer.NAND = 62;
vlgLexer.NOR = 63;
vlgLexer.XOR = 64;
vlgLexer.ASSIGN = 65;
vlgLexer.PLUS = 66;
vlgLexer.MINUS = 67;
vlgLexer.AND = 68;
vlgLexer.OR = 69;
vlgLexer.MUL = 70;
vlgLexer.DIV = 71;
vlgLexer.LT = 72;
vlgLexer.LTE = 73;
vlgLexer.GT = 74;
vlgLexer.GTE = 75;
vlgLexer.EQUAL = 76;
vlgLexer.NOTEQUAL = 77;
vlgLexer.SHL = 78;
vlgLexer.SHR = 79;
vlgLexer.One_line_comment = 80;
vlgLexer.Block_comment = 81;
vlgLexer.IDENTIFIER = 82;
vlgLexer.White_space = 83;

vlgLexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

vlgLexer.prototype.modeNames = [ "DEFAULT_MODE" ];

vlgLexer.prototype.literalNames = [ null, "'module'", "';'", "'endmodule'", 
                                    "'#'", "'('", "'parameter'", "')'", 
                                    "','", "'reg'", "'input'", "'output'", 
                                    "'test'", "'begin'", "'end'", "'{'", 
                                    "'}'", "'$display'", "'localparam'", 
                                    "'wire'", "'.'", "'and'", "'or'", "'xor'", 
                                    "'nand'", "'nor'", "'xnor'", "'not'", 
                                    "'control'", "'response'", "'buffer'", 
                                    "'sevenseg'", "'number'", "'led'", "'leds'", 
                                    "'ledbar'", "'assign'", "'$meta'", "'initial'", 
                                    "'always'", "'@'", "'posedge'", "'negedge'", 
                                    "'if'", "'else'", "'case'", "'endcase'", 
                                    "':'", "'default'", "'$error'", "'?'", 
                                    "'['", "']'", "'''", "'\"'", "'Main'", 
                                    null, null, null, null, "'!'", "'~'", 
                                    "'~&'", "'~|'", "'^'", "'='", "'+'", 
                                    "'-'", "'&'", "'|'", "'*'", "'/'", "'<'", 
                                    "'<='", "'>'", "'>='", "'=='", "'!='", 
                                    "'<<'", "'>>'" ];

vlgLexer.prototype.symbolicNames = [ null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, null, null, null, null, null, 
                                     null, "MAIN", "Decimal_number", "Binary_number", 
                                     "Octal_number", "Hex_number", "NOT", 
                                     "NEG", "NAND", "NOR", "XOR", "ASSIGN", 
                                     "PLUS", "MINUS", "AND", "OR", "MUL", 
                                     "DIV", "LT", "LTE", "GT", "GTE", "EQUAL", 
                                     "NOTEQUAL", "SHL", "SHR", "One_line_comment", 
                                     "Block_comment", "IDENTIFIER", "White_space" ];

vlgLexer.prototype.ruleNames = [ "T__0", "T__1", "T__2", "T__3", "T__4", 
                                 "T__5", "T__6", "T__7", "T__8", "T__9", 
                                 "T__10", "T__11", "T__12", "T__13", "T__14", 
                                 "T__15", "T__16", "T__17", "T__18", "T__19", 
                                 "T__20", "T__21", "T__22", "T__23", "T__24", 
                                 "T__25", "T__26", "T__27", "T__28", "T__29", 
                                 "T__30", "T__31", "T__32", "T__33", "T__34", 
                                 "T__35", "T__36", "T__37", "T__38", "T__39", 
                                 "T__40", "T__41", "T__42", "T__43", "T__44", 
                                 "T__45", "T__46", "T__47", "T__48", "T__49", 
                                 "T__50", "T__51", "T__52", "T__53", "MAIN", 
                                 "Decimal_number", "Binary_number", "Octal_number", 
                                 "Hex_number", "Sign", "Size", "Non_zero_unsigned_number", 
                                 "Unsigned_number", "Binary_value", "Octal_value", 
                                 "Hex_value", "Decimal_base", "Binary_base", 
                                 "Octal_base", "Hex_base", "Non_zero_decimal_digit", 
                                 "Decimal_digit", "Binary_digit", "Octal_digit", 
                                 "Hex_digit", "X_digit", "Z_digit", "NOT", 
                                 "NEG", "NAND", "NOR", "XOR", "ASSIGN", 
                                 "PLUS", "MINUS", "AND", "OR", "MUL", "DIV", 
                                 "LT", "LTE", "GT", "GTE", "EQUAL", "NOTEQUAL", 
                                 "SHL", "SHR", "One_line_comment", "Block_comment", 
                                 "IDENTIFIER", "White_space" ];

vlgLexer.prototype.grammarFileName = "vlg.g4";


exports.vlgLexer = vlgLexer;

